import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";

const CompanyCurrencyModal = ({ show, onClose, heading, initialData, onSuccess }) => {
    const initialFormState = {
        company_id: "",
        currency: "",
        symbol: "",
        position: "",
        decimal_format: "",
        conversion_rate: "",
        is_default: 0,
    };

    const [formData, setFormData] = useState(initialFormState);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const company_id = localStorage.getItem("companyID");
        if (initialData) {
            setFormData(initialData);
        } else {
            setFormData({ ...initialFormState, company_id });
        }
    }, [initialData, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.currency || !formData.conversion_rate) {
            Swal.fire("Validation Error", "Please fill all required fields", "warning");
            return;
        }

        try {
            setLoading(true);
            if (initialData?.id) {
                await axios.put(`${API_URL}/company-currencies/${initialData.id}`, formData);
            } else {
                await axios.post(`${API_URL}/company-currencies`, formData);
            }

            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Currency saved successfully",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            onClose();
            onSuccess();
        } catch (err) {
            Swal.fire(
                "Error",
                err.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Currency</label>
                        <input
                            type="text"
                            className="form-control"
                            name="currency"
                            value={formData.currency}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Conversion Rate</label>
                        <input
                            type="number"
                            step="0.0001"
                            className="form-control"
                            name="conversion_rate"
                            value={formData.conversion_rate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Currency Symbol</label>
                        <input
                            type="text"
                            className="form-control"
                            name="symbol"
                            value={formData.symbol}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {/* Currency Position */}
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Currency Position</label>
                        <select
                            className="form-select"
                            name="position"
                            value={formData.position}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Position</option>
                            <option value="pre">Pre</option>
                            <option value="post">Post</option>
                        </select>
                    </div>

                    {/* Decimal Number Format */}
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Decimal Number Format</label>
                        <input
                            type="number"
                            className="form-control"
                            name="decimal_format"
                            value={formData.decimal_format}
                            onChange={handleChange}
                            min={0}
                            max={8}
                            step={1}
                            required
                        />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label d-block">Set as Default</label>

                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="is_default"
                                name="is_default"
                                checked={formData.is_default === 1}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        is_default: e.target.checked ? 1 : 0,
                                    })
                                }
                                style={{
                                    width: "45px"
                                }}
                            />
                            <label className="form-check-label" htmlFor="is_default">
                                Yes
                            </label>
                        </div>
                    </div>




                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CompanyCurrencyModal;
